// store/slices/userSlice.ts
import { FormConfigType, initialCustomFormState } from "@/utils/types/store";

export interface UserState {
  userId: string | null;
  userDetails: {
    userName?: string | null;
    email?: string | null;
    role?: string;
    roles?: any[]; // Added roles
  };
  userCustomFormData: FormConfigType;
  profilePicture: string | null;
  brandLogo: string | null;
  brandIcon?: string | null;
  subscriptionPlan: string | null;
  subscriptionStatus: string | null;
  pendingVerificationEmail: string | null;
}

export interface UserActions {
  setUserData: (data: { userId: string }) => void;
  setUserDetails: ({
    userName,
    email,
    roles,
  }: {
    userName?: string | null;
    email?: string | null;
    roles?: any[];
  }) => void;
  setUserCustomFormData: (data: FormConfigType) => void;
  setProfilePicture: (profilePicture: string) => void;
  setBrandLogo: (brandLogo: string) => void;
  setBrandIcon: (brandIcon: string) => void;
  setSubscriptionPlan: (plan: string | null) => void;
  setSubscriptionStatus: (status: string | null) => void;
  setPendingVerificationEmail: (email: string | null) => void;
}

export const userSlice = (
  set: any,
): { data: UserState; actions: UserActions } => ({
  data: {
    userId: null,
    userDetails: {
      userName: null,
      email: null,
      role: "user",
      roles: [],
    },
    userCustomFormData: initialCustomFormState,
    profilePicture: null,
    brandLogo: null,
    brandIcon: null,
    subscriptionPlan: null,
    subscriptionStatus: null,
    pendingVerificationEmail: null,
  },
  actions: {
    setUserData: (data: { userId: string }) => {
      set((state: any) => {
        state.data.userId = data.userId;
      });
    },
    setUserDetails: ({ userName, email, roles }) => {
      set((state: any) => {
        state.data.userDetails = {
          userName,
          email,
          roles: roles || [],
        };
      });
    },
    setUserCustomFormData: (formData: any) => {
      set((state: any) => {
        state.data.userCustomFormData = formData;
      });
    },
    setProfilePicture: (profilePicture: string) => {
      set((state: any) => {
        state.data.profilePicture = profilePicture;
      });
    },
    setBrandLogo: (brandLogo: string) => {
      set((state: any) => {
        state.data.brandLogo = brandLogo;
      });
    },
    setBrandIcon: (brandIcon: string) => {
      set((state: any) => {
        state.data.brandIcon = brandIcon;
      });
    },
    setSubscriptionPlan: (plan: string | null) => {
      set((state: any) => {
        state.data.subscriptionPlan = plan;
      });
    },
    setSubscriptionStatus: (status: string | null) => {
      set((state: any) => {
        state.data.subscriptionStatus = status;
      });
    },
    setPendingVerificationEmail: (email: string | null) => {
      set((state: any) => {
        state.data.pendingVerificationEmail = email;
      });
    },
  },
});
